import React from 'react';
import {AppBar,Toolbar,Button,Slide,useScrollTrigger,CssBaseline} from '@material-ui/core';
import { bubble as Menu } from 'react-burger-menu'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme,makeStyles } from '@material-ui/core/styles';
import ContactDialog from './ContactDialog';
import useWindowScroll from '@react-hook/window-scroll'

var Scroll = require('react-scroll');
var scroller = Scroll.scroller;
var scroll = Scroll.animateScroll;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    //flexGrow: 1,
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    color:'black'
  },
}));


function HideOnScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

var styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '26px',
    height: '20px',
    right: '36px',
    top: '20px'
  },
  bmBurgerBars: {
    background: '#787878'
  },
  bmBurgerBarsHover: {
    background: '#a90000'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: '#bdc3c7'
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%'
  },
  bmMenu: {
    background: '#e7e7e7',
    padding: '1.5em 1.5em 0',
    fontSize: '1.15em'
  },
  bmMorphShape: {
    fill: '#e7e7e7'
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em'
  },
  bmItem: {
    display: 'inline-block'
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)'
  }
}


export default function NavBar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const [isMenuOpen, showMenu] = React.useState(false);
  const [isDialogOpen, showDialog] = React.useState(false);
  const scrollY = useWindowScroll(60 )

  const handleOpenDialog = () => {
    showDialog(true);
  };

  const handleCloseDialog = () => {
    showDialog(false);
  };

  function scrollTo(element){
    scroller.scrollTo(element, {
      duration: 1500,
      smooth: true,
    })
  }
  function scrollToTop(){
    scroll.scrollToTop({
      duration: 1500,
      smooth: true,
    })
  }

  function ChangeMenuState(newState){
    showMenu(newState.isOpen)
  }
  return (
    <div className={classes.root}>
        <CssBaseline />
        <HideOnScroll {...props}>
      <AppBar elevation={0} style={{color:'black',background:'none',backgroundImage:smDown?'radial-gradient(circle farthest-side at right, rgba(255,255,255,0.6) 0%, transparent 55%)':'radial-gradient(circle farthest-side at left, rgba(255,255,255,0.6) 0%, transparent 55%)',justifyContent:'start',zIndex:300}}>
        
        <Toolbar>  
          <Button onClick={scrollY>10?()=>scrollToTop():null}><span aria-label="hi" role="img">{scrollY>10?'☝🏼':'🖐🏼'}</span></Button>
          {!smDown &&
          <>
          <Button onClick={()=>scrollTo('Web')}>Web</Button>
          <Button onClick={()=>scrollTo('Mobile')}>Mobile</Button>
          <Button onClick={()=>scrollTo('ML')}>ML & CG</Button>
          <Button onClick={()=>scrollTo('DesignAndOther')}>Design</Button>
          <Button onClick={handleOpenDialog}><span aria-label="contact" role="img">💌 </span> Contact Me</Button>
          </>
          }
        </Toolbar>
      </AppBar>
      </HideOnScroll>

       <ContactDialog  isDialogOpen={isDialogOpen} handleCloseDialog={handleCloseDialog} handleOpenDialog={handleOpenDialog} /> 
       {smDown &&
          <Menu onStateChange={ChangeMenuState} isOpen={isMenuOpen}  styles={ styles }>
          <Button onClick={()=>{showMenu(false);scrollToTop()}} style={{textAlign:'left'}}><span aria-label="hi" role="img">🖐🏼</span> Portfolio 2.0</Button>
          <br />
          <Button onClick={()=>{showMenu(false);scrollTo('Web')}}  style={{textAlign:'left'}}><span style={{whiteSpace:'pre'}}>        </span>Web</Button>
          <br />
          <Button onClick={()=>{showMenu(false);scrollTo('Mobile')}}><span style={{whiteSpace:'pre'}}>        </span>Mobile</Button>
          <br />
          <Button onClick={()=>{showMenu(false);scrollTo('ML')}}><span style={{whiteSpace:'pre'}}>        </span>ML & CG</Button>
          <br />
          <Button onClick={()=>{showMenu(false);scrollTo('DesignAndOther')}}><span style={{whiteSpace:'pre'}}>        </span>Design</Button>
          <br />
          <Button onClick={handleOpenDialog}><span aria-label="contact" role="img">💌 </span> Contact Me</Button>
          </Menu>
        }

    </div>
  );
}